export default "__VITE_ASSET__9Rdom9yL__"